'use client';

/**
 * AguaSVG - Representación visual del nivel de agua y animación de olas.
 * Se mantiene como elementos SVG puros para asegurar la compatibilidad 
 * dentro del contenedor <svg> del Raceway.
 */

type AguaProps = {
  x: number;
  y: number;
  width: number;
  height: number;
  nivel: number;
  encendido?: boolean;
};

export default function AguaSVG({ x, y, width, height, nivel, encendido }: AguaProps) {
  // Cálculo proporcional de la altura del agua basada en el porcentaje de nivel
  const aguaHeight = (height * nivel) / 100;
  const aguaY = y + height - aguaHeight;

  // Si el nivel es 0, no renderizamos nada para optimizar el DOM
  if (nivel <= 0) return null;

  return (
    <g>
      <defs>
        {/* Definimos el área de recorte para que el agua no se salga de los límites del depósito */}
        <clipPath id={`clip-${x}-${y}`}>
          <rect x={x} y={y} width={width} height={height} />
        </clipPath>
      </defs>

      <g clipPath={`url(#clip-${x}-${y})`}>
        {/* Cuerpo del agua: Cyan oscuro con opacidad para efecto de profundidad */}
        <rect 
          x={x} 
          y={aguaY} 
          width={width} 
          height={aguaHeight} 
          fill="#0e7490" // cyan-700
          opacity="0.65" 
        />

        {/* Ola superficial: Línea animada con curvas de Bézier */}
        <path
          d={`M${x} ${aguaY} Q${x + width * 0.25} ${aguaY - 4} ${x + width * 0.5} ${aguaY} Q${x + width * 0.75} ${aguaY + 4} ${x + width} ${aguaY}`}
          fill="none" 
          stroke="#67e8f9" // cyan-300
          strokeWidth="2" 
          opacity={encendido ? "1" : "0.4"}
        >
          {encendido && (
            <animate 
              attributeName="d"
              values={`
                M${x} ${aguaY} Q${x + width * 0.25} ${aguaY - 4} ${x + width * 0.5} ${aguaY} Q${x + width * 0.75} ${aguaY + 4} ${x + width} ${aguaY};
                M${x} ${aguaY} Q${x + width * 0.25} ${aguaY + 4} ${x + width * 0.5} ${aguaY} Q${x + width * 0.75} ${aguaY - 4} ${x + width} ${aguaY};
                M${x} ${aguaY} Q${x + width * 0.25} ${aguaY - 4} ${x + width * 0.5} ${aguaY} Q${x + width * 0.75} ${aguaY + 4} ${x + width} ${aguaY}
              `}
              dur="2s" 
              repeatCount="indefinite"
            />
          )}
        </path>

        {/* Capa de tinte "Algae": Verde esmeralda que aparece cuando el motor está activo */}
        {encendido && (
          <rect 
            x={x} 
            y={aguaY} 
            width={width} 
            height={aguaHeight} 
            fill="#15803d" // green-700
            opacity="0.15" 
          />
        )}
      </g>
    </g>
  );
}